import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/quotation';

export type Compositions = Awaited<
  ReturnType<(typeof service)['getCompositions']>
>;

export function getCompositionsOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Compositions>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['compositions', [guid], [search]],
    queryFn: async () => await service.getCompositions(guid),
    initialData,
  });
}
